import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Grid } from '../../../core/components/grid/grid.model';

@Component({
  selector: 'tt-component-alternatives',
  templateUrl: './component-alternatives.component.html',
  styleUrls: ['./component-alternatives.component.css']
})
export class ComponentAlternativesComponent implements OnInit {
    prodId;

    compKeyno;

    public setting?: Setting;

    public grid?: GridOptions;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.prodId = this.stateService.getStateParams()['prod_id'];
        this.compKeyno = this.stateService.getStateParams()['comp_keyno'];
    }

    private async loadSetting() {
        if (!!this.prodId && !!this.compKeyno) {
            this.setting = (await this.datatask.Post(2402, {
                prod_id: this.prodId,
                comp_keyno: this.compKeyno
            }))[0];
        }
    }

    private loadGrid() {
        if (!!this.setting) {
            if (!this.grid) {
                this.grid = new Grid()
                    .setRememberId(this.setting.view_id)
                    .setLoadDataFunction({
                        method: this.setting.p2_datatask_keyno,
                        parameters: this.setting
                    })
                    .setKendoConfig({ height: '100%' })
                    .setToolbar({ wrapping: true })
                    .setCustomToolbarButtons([{
                        name: 'componentalternatives_new',
                        text: 'componentalternatives_new',
                        func: () => {
                            this.stateService?.go('componentalternative', {
                                prod_id: this.setting?.prod_keyno,
                                comp_keyno: this.setting?.comp_keyno,
                                componentalternative_keyno: '0'
                            })
                        },
                        icon: 'fas fa-plus',
                        cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
                        translate: true
                    }]);
            } else {
                this.grid?.gridfunc?.read();
            }
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    prod_id: string;
    prod_name: string;
    comp_keyno: string;
    p2_datatask_keyno: number;
    view_id: string;
    prod_keyno: string;
}
